import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleCompany from "@/store/company/moduleCompany.js";
import OptimizerManager from "@/models/OptimizerManager";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import ManageErrorMessages from "@/models/ManageErrorMessages";
import DateUtils from "@/helpers/DateUtils.js";

export const optimizerManagerEditMixin = {
	name: "OptimizerManagerEdit",
	components: {
		vSelect,
		flatPickr,
		Datepicker,
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			optimizerManager: JSON.parse(JSON.stringify(this.data)),
			langHe: es,
			langEn: en,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			companyOptions: [],
			optimizerOptions: [],
			dangerInput: {
				name: {show: false, text: ""},
				identification: {show: false, text: ""},
				apikey: {show: false, text: ""},
				city: {show: false, text: ""},
				country: {show: false, text: ""},
				phone: {show: false, text: ""},
				cy: {show: false, text: ""},
				cx: {show: false, text: ""},
			},
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			optimizerList: [
				{label: "OPENROUTE", value: "OPENROUTE"},
				{label: "GMPRO", value: "GMPRO"},
				{label: "TOUR PLANNING", value: "TOUR_PLANNING"},
				{label: "SERVIROUTES", value: "SERVIROUTES"},
			],
			serviceList: [
				{label: this.$t("Optimization.Optimization"), value: "optimization"},
				{label: this.$t("RoutingService"), value: "routing"},
				{label: this.$t("Matrix"), value: "matrix"},
				{label: this.$t("MapMatching"), value: "mapmatching"},
				{label: this.$t("Isochrones"), value: "isochrones"},
				{label: this.$t("Clustering.Title"), value: "clustering"},
			],
		};
	},
	created() {
		// modulo de empresa
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		Validator.extend("validatorExpireDate", this.validatorExpireDate);
	},
	mounted() {
		this.showMap = true;
		this.optimizerManager.api_enable = this.optimizerManager.api_enable === 1 ? true : false;
		this.optimizerManager.web_enable = this.optimizerManager.web_enable === 1 ? true : false;
		this.getCompany();
	},
	watch: {
		"optimizerManager.optimization_api"(newVal) {
			if (newVal === "SERVIROUTES") {
				this.optimizerManager.service = "clustering";
			} else if (newVal === "TOUR_PLANNING") {
				this.optimizerManager.service = "routing";
			} else if (newVal !== "OPENROUTE") {
				this.optimizerManager.service = "optimization";
			}
		},
	},
	computed: {
		disabledDatesTo() {
			return {to: new Date()};
		},
		validateForm() {
			return !this.errors.any();
		},
		filteredServiceList() {
			const api = this.optimizerManager.optimization_api;
			if (api === "SERVIROUTES") {
				return this.serviceList.filter((s) => s.value === "clustering");
			}
			if (api === "TOUR_PLANNING") {
				return this.serviceList.filter((s) => s.value === "routing" || s.value === "optimization");
			}
			if (api === "GMPRO") {
				return this.serviceList.filter((s) => s.value === "optimization");
			}
			return this.serviceList.filter((s) => s.value !== "clustering");
		},
		selectedCompany: {
			get() {
				const found = this.companyOptions.find((company) => company.value === this.optimizerManager.company_id);
				return {
					label: found === undefined ? "" : found.label,
					value: found === undefined ? "" : found.value,
				};
			},
			set(obj) {
				this.optimizerManager.company_id = obj.value;
			},
		},
		selectedOptimizationApi: {
			get() {
				const found = this.optimizerList.find(
					(optimizer) => optimizer.value === this.optimizerManager.optimization_api
				);
				return {
					label: found === undefined ? "" : found.label,
					value: found === undefined ? "" : found.value,
				};
			},
			set(obj) {
				this.optimizerManager.optimization_api = obj.value;
			},
		},
		selectedService: {
			get() {
				const found = this.serviceList.find((service) => service.value === this.optimizerManager.service);
				return {
					label: found === undefined ? "" : found.label,
					value: found === undefined ? "" : found.value,
				};
			},
			set(obj) {
				this.optimizerManager.service = obj.value;
			},
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getCompany() {
			this.openLoading();
			this.$store
				.dispatch("moduleCompany/fetchDataListItems")
				.then((res) => {
					this.companyOptions = res.data.map((company) => {
						return {label: company.name, value: company.id};
					});
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		validatorExpireDate(value, args) {
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const expDate = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const optimizerDate =
				typeof this.optimizerManager.date_end === "string"
					? new Date(this.optimizerManager.date_end).getTime()
					: this.optimizerManager.date_end.getTime();
			return expDate <= optimizerDate;
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.updateOptimizerManager();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
					this.activeTab = 0;
				}
			});
		},
		updateOptimizerManager() {
			delete this.optimizerManager.id;
			this.optimizerManager["optimization_api"] = this.selectedOptimizationApi.value || "";
			const apiVal = this.selectedOptimizationApi.value;
			this.optimizerManager["service"] =
				(apiVal === "OPENROUTE" ||
					apiVal === "SERVIROUTES" ||
					apiVal === "TOUR_PLANNING" ||
					apiVal === "GMPRO") &&
				this.selectedService
					? this.selectedService.value
					: "optimization";
			this.optimizerManager["company_id"] = this.selectedCompany.value || "";
			this.optimizerManager["api_key"] =
				this.optimizerManager.api_key === null || this.optimizerManager.api_key === undefined
					? ""
					: this.optimizerManager.api_key;
			this.optimizerManager["date_end"] = DateUtils.toDefaultDateTime(
				this.optimizerManager.date_end,
				"YYYY-MM-DD"
			);
			this.optimizerManager["points_per_month"] =
				this.optimizerManager.points_per_month >= 0 ? parseInt(this.optimizerManager.points_per_month) : null;
			this.optimizerManager["points_per_week"] =
				this.optimizerManager.points_per_week >= 0 ? parseInt(this.optimizerManager.points_per_week) : null;
			this.optimizerManager["points_per_day"] =
				this.optimizerManager.points_per_day >= 0 ? parseInt(this.optimizerManager.points_per_day) : null;
			this.optimizerManager["points_total"] =
				this.optimizerManager.points_total >= 0 ? parseInt(this.optimizerManager.points_total) : null;
			this.optimizerManager["points_subscription_monthly"] =
				this.optimizerManager.points_subscription_monthly >= 0
					? parseInt(this.optimizerManager.points_subscription_monthly)
					: null;
			this.$store
				.dispatch("optimizerManager/update", {items: this.optimizerManager, id: this.$route.params.id})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("OptimizerManager.EditSuccess.Title"),
						text: this.$t("OptimizerManager.EditSuccess.Text"),
					});
					this.optimizerManager = new OptimizerManager({});
					this.$router.push({name: "app-optimizer-manager-list"});
				})
				.catch((error) => {
					this.manageErrorMessages.processErrorOptimizerManager(error.data[0]);
					console.error(error);
				});
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
	},
};
